module.exports = __webpack_public_path__ + "static/media/026.ff5a74df.jpg";